'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const FileCopyIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.25 18.25V20.25C17.25 20.8023 16.8023 21.25 16.25 21.25H5.75C5.19772 21.25 4.75 20.8023 4.75 20.25V6.75C4.75 6.19772 5.19772 5.75 5.75 5.75H7.75M15.25 2.75H8.75C8.19772 2.75 7.75 3.19772 7.75 3.75V17.25C7.75 17.8023 8.19771 18.25 8.75 18.25H19.25C19.8023 18.25 20.25 17.8023 20.25 17.25V7.75M15.25 2.75L20.25 7.75M15.25 2.75V6.75C15.25 7.30228 15.6977 7.75 16.25 7.75H20.25",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const VpFileCopyIcon = forwardRef(FileCopyIcon);

export { VpFileCopyIcon as default };
